import AttachFileIcon from "@mui/icons-material/AttachFile";
import Delete from "@mui/icons-material/Delete";
import {
	Button,
	IconButton,
	Modal,
	Paper,
	Typography,
	useTheme,
} from "@mui/material";
import { useSnackbar } from "notistack";
import { useEffect, useRef, useState } from "react";
import { CandidatePageData } from "../interfaces/Candidate";
import Resume, { Education, Expirience } from "../interfaces/Resume";
import { Direction } from "../pages/Specilization";
import {
	Createresume,
	GetDirections,
	Updateresume,
} from "../requester/functions";
import { MAIN_URL, P } from "../requester/requester";
import VO, { VK } from "../utilities/validate";
import DataDate from "./DataInputs/DataDate";
import DataSelect from "./DataInputs/DataSelect";
import DataSwitch from "./DataInputs/DataSwitch";
import DataTextField from "./DataInputs/DataTextField";

interface IProps {
	open: boolean;
	onClose(isUpdate?: boolean): void;
	resume?: Resume;
	userId: number;
	user?: CandidatePageData;
}

const expTemplate = {
	name_organization: "",
	position: "",
	start_date: "",
	end_date: "",
	description: "",
};

const eduTemplate = {
	name_organization: "",
	date_end: "",
	name_faculty: "",
	direction: "",
	form: 0,
};

const template: Resume = {
	first_name: "",
	last_name: "",
	city: "",
	text_resume: "",
	family_status: false,
	position: "",
	citizenship: "",
	ready_to_move: false,
	ready_for_trips: false,
	desired_salary: 0,
	phone: "",
	email: "",
	short: false,
	resume_directions: [],
	education: [],
	experience: [],
};

const CreateResumeModal = (props: IProps) => {
	const theme = useTheme();
	const { enqueueSnackbar } = useSnackbar();

	const [resume, setResume] = useState<Resume>(template);

	const [isEdit, setIsEdit] = useState<boolean>(false);

	const [directions, setDirections] = useState<Direction[]>([]);
	const file = useRef<any>(undefined);
	const [doc, setDoc] = useState<any>();
	const [fileName, setFileName] = useState<string>("");

	const [education, setEducation] = useState<Education | null>(null);
	const [experience, setExpirience] = useState<Expirience | null>(null);
	const [educationIndex, setEducationIndex] = useState<number>(-1);

	const [experienceIndex, setExpirienceIndex] = useState<number>(-1);

	const getIndex = (d: Direction) => {
		const i = resume.resume_directions.indexOf(d.id);
		return i;
	};

	useEffect(() => {
		setEducation({ ...resume.education[educationIndex] });
	}, [educationIndex]);

	useEffect(() => {
		var eventResume = resume;
		if (education) eventResume.education[educationIndex] = education;
		setResume({ ...eventResume });
	}, [education]);

	useEffect(() => {
		setExpirience({ ...resume.experience[experienceIndex] });
	}, [experienceIndex]);

	useEffect(() => {
		var eventResume = resume;
		if (experience) eventResume.experience[experienceIndex] = experience;
		setResume({ ...eventResume });
	}, [experience]);

	useEffect(() => {
		if (props.resume) {
			setResume({ ...props.resume });
			setIsEdit(true);
		} else {
			var eventTemplate = { ...template };
			let names = props.user?.full_name.split(" ");
			if (names) {
				eventTemplate.first_name = names[0];
				eventTemplate.last_name = names[1];
				if (names.length > 2) {
					eventTemplate.patronymic = names[2];
				}
			}
			eventTemplate.email = props.user?.email || "";
			eventTemplate.phone = props.user?.phone || "";
			setResume({ ...eventTemplate });
			setIsEdit(false);
		}
		setDoc(undefined);
	}, [props.resume]);

	useEffect(() => {
		GetDirections({}, (resp) => {
			if (resp.status === "ok" && resp.data) setDirections(resp.data);
		});
	}, []);

	return (
		<Modal
			open={props.open}
			onClose={() => {
				props.onClose();
			}}
			className="flex items-center flex-col overflow-auto py-10"
		>
			<Paper className="focus-visible:outline-none p-5 max-w-[900px]  flex flex-col gap-5 ">
				<div className="flex">
					<DataTextField
						value={resume}
						setValue={setResume}
						keyValue="first_name"
						inputProps={{
							required: true,
							label: "Имя",
							error: !VK(resume.first_name),
						}}
					/>
					<DataTextField
						value={resume}
						setValue={setResume}
						keyValue="last_name"
						inputProps={{
							required: true,
							label: "Фамилия",
							error: !VK(resume.last_name),
						}}
					/>
					<DataTextField
						value={resume}
						setValue={setResume}
						keyValue="patronymic"
						inputProps={{
							label: "Отчество",
						}}
					/>
					<p className="ml-10"></p>
					<DataSwitch
						value={resume}
						setValue={setResume}
						keyValue={"family_status"}
						label="В браке"
					/>
				</div>
				<DataTextField
					value={resume}
					setValue={setResume}
					keyValue="position"
					inputProps={{
						required: true,
						label: "Должность",
						error: !VK(resume.position),
					}}
				/>
				<DataTextField
					value={resume}
					setValue={setResume}
					keyValue="citizenship"
					inputProps={{
						required: true,
						label: "Гражданство",
						error: !VK(resume.citizenship),
					}}
				/>
				<DataTextField
					value={resume}
					setValue={setResume}
					keyValue="second_citizenship"
					inputProps={{
						label: "Второе гражданство",
					}}
				/>
				<DataTextField
					value={resume}
					setValue={setResume}
					keyValue="city"
					inputProps={{
						required: true,
						label: "Город",
						error: !VK(resume.city),
					}}
				/>
				<DataSwitch
					value={resume}
					setValue={setResume}
					keyValue={"ready_to_move"}
					label="Готовность к переезду"
				/>
				<DataSwitch
					value={resume}
					setValue={setResume}
					keyValue={"ready_for_trips"}
					label="Готовность к командировкам"
				/>
				<DataTextField
					value={resume}
					setValue={setResume}
					keyValue="desired_salary"
					inputProps={{
						type: "number",
						required: true,
						label: "Желаемая зарплата",
						error: !VK(resume.desired_salary),
					}}
				/>
				<DataTextField
					value={resume}
					setValue={setResume}
					keyValue="phone"
					inputProps={{
						required: true,
						label: "Телефон",
						error: !VK(resume.phone),
					}}
				/>
				<DataTextField
					value={resume}
					setValue={setResume}
					keyValue="email"
					inputProps={{
						required: true,
						label: "Почта",
						error: !VK(resume.email),
					}}
				/>
				<Typography>Образование</Typography>
				<div className="flex flex-wrap gap-2">
					{resume.education.map((e, i) => (
						<Paper
							className=" flex items-center gap-2 py-1 px-2 select-none cursor-pointer"
							sx={{
								background:
									i === educationIndex ? theme.palette.primary.main : "",
								borderWidth: "2px",
								borderColor: VO(e, eduTemplate) ? "" : theme.palette.error.main,
							}}
						>
							<div
								className="h-full w-full flex items-center"
								onClick={() => {
									setEducationIndex(i);
								}}
							>
								<Typography>{e.name_organization || "Образование"}</Typography>
							</div>
							<IconButton
								color="error"
								onClick={() => {
									var r = { ...resume };
									var indexEdu = r.education.indexOf(e);

									r.education.splice(indexEdu, 1);
									var currentIndex =
										indexEdu > 0
											? 0
											: indexEdu < r.education.length - 1
											? indexEdu + 1
											: -1;

									if (currentIndex === -1) setEducation(null);
									setEducationIndex(currentIndex);

									setResume({ ...r });
								}}
							>
								<Delete />
							</IconButton>
						</Paper>
					))}
				</div>
				{educationIndex > -1 && resume.education.length > 0 ? (
					<div className="w-full flex flex-wrap justify-between gap-3">
						<DataTextField
							className="w-[48%]"
							value={education}
							setValue={setEducation}
							keyValue={"name_organization"}
							inputProps={{
								required: true,
								error: !VK(education?.name_organization),
								label: "Название заведения",
							}}
						/>
						<DataTextField
							className="w-[48%]"
							value={education}
							setValue={setEducation}
							keyValue={"date_end"}
							inputProps={{
								type: "number",
								required: true,
								error: !VK(education?.date_end),
								label: "Год окончания",
							}}
						/>
						<DataTextField
							className="w-[48%]"
							value={education}
							setValue={setEducation}
							keyValue={"name_faculty"}
							inputProps={{
								required: true,
								error: !VK(education?.name_faculty),
								label: "Название факультета",
							}}
						/>
						<DataTextField
							className="w-[48%]"
							value={education}
							setValue={setEducation}
							keyValue={"direction"}
							inputProps={{
								required: true,
								error: !VK(education?.direction),
								label: "Направление / специальность",
							}}
						/>
						<DataSelect
							list={[
								{ name: "Очная", id: 1 },
								{ name: "Заочная", id: 2 },
								{ name: "Очно-заочная", id: 3 },
								{ name: "Вечерняя", id: 4 },
							]}
							value={education}
							setValue={setEducation}
							keyValue={"form"}
							label="Форма обучения"
							inputProps={{
								required: true,
								error: !VK(education?.form),
							}}
						/>
					</div>
				) : null}

				<Button
					onClick={() => {
						var eventResume = resume;
						var eventEducation: Education = {
							name_organization: "",
							date_end: "",
							name_faculty: "",
							direction: "",
							form: 0,
						};

						setEducation(eventEducation);
						eventResume.education.push(eventEducation);
						setResume({ ...eventResume });
						setEducationIndex(eventResume.education.length - 1);
					}}
				>
					{" "}
					Добавить
				</Button>
				<Typography>Опыт работы</Typography>
				<div className="flex flex-wrap gap-2">
					{resume.experience.map((e, i) => (
						<Paper
							onClick={() => {
								setExpirienceIndex(i);
							}}
							className="py-1 px-2 flex items-center select-none cursor-pointer"
							sx={{
								background:
									i === experienceIndex ? theme.palette.primary.main : "",
								borderWidth: "2px",
								borderColor: VO(e, expTemplate) ? "" : theme.palette.error.main,
							}}
						>
							<div
								className="h-full w-full flex items-center"
								onClick={() => {
									setEducationIndex(i);
								}}
							>
								<Typography>{e.name_organization || "Работа"}</Typography>
							</div>
							<IconButton
								color="error"
								onClick={() => {
									var r = { ...resume };
									var indexExp = r.experience.indexOf(e);

									r.experience.splice(indexExp, 1);
									var currentIndex =
										indexExp > 0
											? 0
											: indexExp < r.experience.length - 1
											? indexExp + 1
											: -1;

									if (currentIndex === -1) setExpirience(null);
									setExpirienceIndex(currentIndex);

									setResume({ ...r });
								}}
							>
								<Delete />
							</IconButton>
						</Paper>
					))}
				</div>
				{experienceIndex > -1 && resume.experience.length > 0 ? (
					<div className="w-full flex flex-wrap justify-between gap-3">
						<DataTextField
							className="w-[48%]"
							value={experience}
							setValue={setExpirience}
							keyValue={"name_organization"}
							inputProps={{
								label: "Название учереждения",
								required: true,
								error: !VK(experience?.name_organization),
							}}
						/>
						<DataTextField
							className="w-[48%]"
							value={experience}
							setValue={setExpirience}
							keyValue={"position"}
							inputProps={{
								label: "Должность",
								required: true,
								error: !VK(experience?.position),
							}}
						/>
						<DataDate
							value={experience}
							setValue={setExpirience}
							label="Дата начала"
							keyValue={"start_date"}
							inputProps={{
								required: true,
								error: !VK(experience?.start_date),
							}}
						/>

						<DataDate
							value={experience}
							setValue={setExpirience}
							label="Дата окончания"
							keyValue={"end_date"}
							inputProps={{
								required: true,
								error: !VK(experience?.end_date),
							}}
						/>

						<DataTextField
							className="w-full"
							value={experience}
							setValue={setExpirience}
							multiline
							keyValue={"description"}
							inputProps={{
								label: "Описание",
								required: true,
								error: !VK(experience?.description),
							}}
						/>
					</div>
				) : null}

				<Button
					onClick={() => {
						var eventResume = resume;
						var eventExperience: Expirience = {
							name_organization: "",
							position: "",
							start_date: undefined,
							end_date: undefined,
							description: "",
						};

						setExpirience(eventExperience);
						eventResume.experience.push(eventExperience);
						setResume({ ...eventResume });
						setExpirienceIndex(eventResume.experience.length - 1);
					}}
				>
					{" "}
					Добавить
				</Button>
				<DataTextField
					value={resume}
					setValue={setResume}
					keyValue={"languages"}
					inputProps={{
						label: "Языки",
					}}
				/>

				<DataTextField
					value={resume}
					setValue={setResume}
					keyValue={"drive_license"}
					inputProps={{
						label: "Водительские права",
					}}
				/>
				<DataTextField
					value={resume}
					multiline
					setValue={setResume}
					keyValue={"text_resume"}
					inputProps={{
						label: "о себе",
						error: !VK(resume.text_resume),
					}}
				/>
				<Typography>Направления</Typography>
				<div className="flex flex-wrap gap-2">
					{directions.map((d, i) => (
						<Paper
							className="py-1 px-2 select-none cursor-pointer"
							key={`direction-${i}`}
							sx={{
								background:
									getIndex(d) !== -1 ? theme.palette.primary.main : "",
							}}
							onClick={() => {
								var eventResume = resume;
								const i = getIndex(d);
								if (i !== -1) eventResume.resume_directions.splice(i, 1);
								else eventResume.resume_directions.push(d.id);
								setResume({ ...eventResume });
							}}
						>
							{d.name}
						</Paper>
					))}
				</div>
				<div className="flex w-full justify-evenly">
					<input
						type="file"
						ref={file}
						style={{ display: "none" }}
						onChange={(ev) => {
							if (ev.target.files) {
								const fi = ev.target.files[0];

								setResume((r) => {
									r.link_or_text = fi.name;
									return { ...r };
								});
								setDoc(fi);
								setFileName(fi.name);
							}
						}}
					/>
					<DataTextField
						className="w-full"
						value={resume}
						setValue={setResume}
						keyValue={"link_doc"}
						inputProps={{ label: "Ссылка или документ" }}
					/>
					<IconButton
						onClick={() => {
							file.current.click();
						}}
					>
						<AttachFileIcon />
					</IconButton>
				</div>
				{fileName ? <p>{fileName}</p> : null}
				{resume.doc ? (
					<a
						href={`${MAIN_URL}${P.DownloadFile}/${resume.doc}`}
						download={"true"}
					>
						скачать
					</a>
				) : null}
				{isEdit && !resume.create_manager ? null : (
					<Button
						variant="contained"
						disabled={!VO(resume, template)}
						onClick={() => {
							if (!isEdit) {
								Createresume(
									{
										data: { ...resume, id_user: props.userId },
										file: doc,
									},
									(resp) => {
										if (resp.status === "ok") {
											enqueueSnackbar("Резюме создано", {
												variant: "success",
											});
										} else {
											enqueueSnackbar(`Ошибка ${resp.code}, ${resp.message}`, {
												variant: "error",
											});
										}
										props.onClose(true);
									}
								);
							} else
								Updateresume(
									{
										data: { ...resume, id_user: props.userId },
										file: doc,
									},
									() => {
										enqueueSnackbar("Резюме успешно обновлено", {
											variant: "success",
										});
										props.onClose();
									}
								);
						}}
					>
						Сохранить
					</Button>
				)}
			</Paper>
		</Modal>
	);
};

export default CreateResumeModal;
